require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/utils/global.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/utils/global.legacy.js
// module id = 654
// module chunks = 31